import React, { useState } from "react";

const testimonials = [
  {
    text: "The flavour is rich yet perfectly balanced. It feels indulgent but still light and healthy. I’ve replaced my evening snacks with this, and I don’t miss junk food at all. Definitely a premium experience.",
    author: "Rohit Mehra, Delhi"
  },
  {
    text: "The Pudina Punch flavour is incredibly fresh and zingy. It’s perfect for tea-time or post-lunch cravings. You can actually taste the mint without it being overpowering. Absolute favorite!",
    author: "Ananya Singh, Lucknow"
  },
  {
    text: "Tangy Tomato has that perfect balance of spice and sourness. It’s nostalgic yet modern. My kids love it, and I feel good giving them something healthy instead of chips.",
    author: "Vikram Patel, Ahmedabad"
  },
  {
    text: "The Cheese Herbs flavour is creamy, herby, and super satisfying. It tastes indulgent but doesn’t feel heavy. Great for movie nights or late-night munching.",
    author: "Sneha Kapoor, Mumbai"
  },
  // Add more testimonials here
];

export default function TestimonialSlider() {
  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((index + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setIndex((index - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="testimonial-wrapper pb-5" style={
        {
            background:'black'
        }
    }>
      <div className="testimonial-card pt-5">
        <div className="stars" style={{
          color:'gold'
        }}>★★★★★</div>

        <p className="testimonial-text" style={{
          textTransform: 'uppercase',
          lineHeight:'1.1'
        }}>{testimonials[index].text}</p>

        <h4 className="testimonial-author">{testimonials[index].author}</h4>
      </div>

      <div className="arrow-controls mt-5">
        <button className="arrow-btn" onClick={prevSlide}>❮</button>
        <button className="arrow-btn" onClick={nextSlide}>❯</button>
      </div>

      
    </div>
  );
}
